<template>
  <div>
    <Head title="首頁設定" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <homepage-template>
      <div class="w-full flex flex-row items-center justify-end gap-4">
        <Button label="新增" @click="showDialog" />
        <Button label="儲存" @click="saveComponents" />
      </div>

      <div class="w-full pt-3">
        <Draggable
          v-bind="dragOptions"
          :list="current_setting"
          :group="{ name: 'current_setting' }"
        >
          <div
            :key="getItemKey(setting)"
            v-for="(setting, index) in current_setting"
            class="w-full item cursor-move"
          >
            <div class="flex flex-row jusitfy-between items-center gap-2">
              <div>
                <div class="mt-1">
                  <div>
                    <Button
                      class="p-button-danger"
                      :id="'del_' + getItemKey(setting)"
                      label="移除"
                      @click="delComponent(index)"
                    />
                  </div>
                </div>
              </div>
              <div>
                {{
                  setting.type == "ad" ? "[廣告橫幅] 群組" + setting.group : ""
                }}
                {{
                  setting.type == "pc" ? "[商品列表] 群組" + setting.group : ""
                }}
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    </homepage-template>
    <Dialog :visible.sync="show_dialog" :modal="true">
      <template v-if="$page.props.ads_groups.length > 0">
        <div>廣告橫幅</div>
        <div class="flex gap-2">
          <span
            :key="'ads_groups_' + index"
            v-for="(ad, index) in $page.props.ads_groups"
          >
            <Button @click="addComponent('ad', ad)">群組{{ ad }}</Button>
          </span>
        </div>
      </template>

      <template v-if="$page.props.pcs_groups.length > 0">
        <div :class="{ 'mt-2': $page.props.ads_groups.length > 0 }">
          商品列表
        </div>
        <div class="flex gap-2">
          <span
            :key="'pcs_groups_' + index"
            v-for="(pc, index) in $page.props.pcs_groups"
          >
            <Button @click="addComponent('pc', pc)">群組{{ pc }}</Button>
          </span>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import HomepageTemplate from "./Shared/HomepageTemplate";
import Button from "primevue/button";
import Draggable from "vuedraggable";
import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import Dialog from "primevue/dialog";

export default {
  components: {
    ScrollTop,
    Breadcrumb,
    HomepageTemplate,
    Button,
    Draggable,
    InputText,
    InputSwitch,
    Dialog,
  },
  layout: Layout,
  computed: {
    dragOptions() {
      return {
        animation: 0,
        ghostClass: "current_destination",
      };
    },
  },
  data() {
    return {
      breadcrumb_home: {
        label: "頁面管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "首頁設定",
          to: route("admin.homepage"),
          disabled: true,
        },
      ],
      current_setting: this.$page.props.current_setting ?? [],
      show_dialog: false,
    };
  },
  methods: {
    getItemKey(item) {
      if (item.id == null) return item.random;
      else return item.id;
    },
    showDialog() {
      this.show_dialog = true;
    },
    addComponent(type, group = null) {
      this.current_setting.unshift({
        random: Math.random().toString(36).substring(2),
        type: type,
        group: group,
        title: null,
        quantity: 0,
      });

      this.show_dialog = false;
    },
    saveComponents() {
      this.$inertia.post(
        route("admin.homepage.save"),
        {
          setting: this.current_setting,
        },
        {
          only: ["current_setting", "groups", "flash"],
          onSuccess: (page) => {
            this.current_setting = page.props.current_setting;
          },
        }
      );
    },
    delComponent(index) {
      this.current_setting.splice(index, 1);
    },
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

.item {
  @apply relative border rounded border-fh-gray-light p-2 mb-2;
}
</style>

<style>
.current_destination {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>